'use strict';

export const PERCENTAGE_REGEX = /^-?(\d*\.)?\d+%$/;
export const MILLISECONDS_REGEX = /^-?(\d*\.)?\d+ms$/;
export const SECONDS_REGEX = /^-?(\d*\.)?\d+s$/;
//# sourceMappingURL=regex.js.map